/* eslint-disable @typescript-eslint/no-explicit-any */
import { CheckIcon, CreditCardIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

import { BILLING_CYCLES } from "utils/constants";

import Button from "components/Button";
import Container from "components/Container";

import useMethod from "./useMethod";

export default function Method() {
  const { t } = useTranslation();

  const { chosenPackage, billingPeriod, handleClickMethod, handleChangePackage } = useMethod();

  if (!chosenPackage) {
    return null;
  }

  return (
    <Container className="flex flex-col gap-6 pb-6">
      <div className="flex flex-col gap-4">
        <div className="flex justify-between font-medium">
          <div>{t("checkout.chosenPlan")}</div>
          <div onClick={handleChangePackage} className="underline text-general-green-800 cursor-pointer">
            {t("checkout.change")}
          </div>
        </div>

        <div className={`w-full mx-auto border border-general-gray-300 rounded-lg`}>
          <div className="flex items-center justify-between p-5">
            <div>
              <h3 className="text-xl font-semibold">{chosenPackage.metadata.name}</h3>
              <div>
                <div className="font-semibold text-[15px]">
                  {billingPeriod === BILLING_CYCLES.YEARLY.toString()
                    ? chosenPackage.package.pricePerYear
                    : chosenPackage.package.pricePerMonth}
                  KM /{" "}
                  {billingPeriod === BILLING_CYCLES.YEARLY.toString() ? (
                    <span className="font-normal text-[15px]">{t("checkout.yearly")}</span>
                  ) : (
                    <span className="font-normal text-[15px]">{t("checkout.monthly")}</span>
                  )}
                </div>
              </div>
            </div>
          </div>

          <hr className="border-general-gray-300 mx-5" />

          <div className="p-5">
            <ul className="space-y-3">
              <li className="flex items-start gap-2.5">
                <span className="flex-shrink-0">
                  <span className="inline-flex items-center justify-center w-6 h-6 rounded-full border-2 border-general-green-700">
                    <CheckIcon className="w-4 h-4 text-general-green-700 stroke-3" />
                  </span>
                </span>
                <span className="text-sm text-foreground">{chosenPackage.metadata.bestFit}</span>
              </li>
              {chosenPackage.metadata.benefits.map((benefit: any, idx: number) => (
                <li key={idx} className="flex items-start gap-2.5">
                  <span className="flex-shrink-0">
                    <span className="inline-flex items-center justify-center w-6 h-6 rounded-full border-2 border-general-green-700">
                      <CheckIcon className="w-4 h-4 text-general-green-700 stroke-3" />
                    </span>
                  </span>
                  <span className="text-sm text-foreground">{benefit}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <hr className="border-general-gray-300" />
      <div className="flex flex-col gap-4">
        <div>{t("checkout.method.choosePaymentMethod")}</div>
        <div className="flex justify-between items-center border border-general-gray-300 rounded-lg p-4">
          <div className="rounded-md flex justify-between">
            <div className="flex gap-3">
              <div className="rounded-sm bg-general-mint-900 p-3">
                <CreditCardIcon className="stroke-general-green-800" />
              </div>
              <div className="flex flex-col gap-1.5">
                <div className="font-semibold">{t("checkout.method.invoice")}</div>
                <div className="text-[15px] text-general-gray-700">{t("checkout.method.downloadInvoice")}</div>
              </div>
            </div>
          </div>
          <div className="flex items-center">
            <Button type="button" className="w-full md:flex-1 h-12 px-4" onClick={handleClickMethod}>
              {t("button.choose")}
            </Button>
          </div>
        </div>
      </div>
    </Container>
  );
}
